import { makeAutoObservable } from 'mobx';

import { TaxRateInfo } from '../interfaces/tax';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import { challengeTaxService } from '../services/challengeTaxService';

class ChallengeTaxStore {
  private entityId: number | null = null;
  entityTaxRate: TaxRateInfo | null | undefined = undefined; // null - no tax rate, undefined - initial state

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.entityId = null;
    this.entityTaxRate = undefined;
  }

  async getTaxInfo(entityId: number) {
    if (!this.entityId) {
      this.setEntityId(entityId);

      await this.getTaxRate();
    } else if (this.entityId !== entityId) {
      throw new Error('Already used for another entity');
    }
  }

  async getTaxRate() {
    if (!this.entityId) {
      throw new Error('entityId is not set');
    }

    const taxRate = await challengeTaxService.getChallengeTaxRate(this.entityId);

    this.setTaxRate(taxRate);
  }

  async changeTaxRate(taxRate: number) {
    if (!this.entityId) {
      throw new Error('entityId is not set');
    }

    if (this.entityTaxRate?.id) {
      await this.updateTaxRate(this.entityId, this.entityTaxRate.id, taxRate);
    } else {
      await this.createTaxRate(this.entityId, taxRate);
    }
  }

  private async createTaxRate(entityId: number, taxRatePercent: number) {
    const taxRate = await challengeTaxService.createChallengeTaxRate(
      entityId,
      taxRatePercent,
    );

    this.setTaxRate(taxRate);
  }

  private async updateTaxRate(
    entityId: number,
    taxRateId: number,
    taxRatePercent: number,
  ) {
    const taxRate = await challengeTaxService.updateChallengeTaxRate(
      entityId,
      taxRateId,
      taxRatePercent,
    );

    this.setTaxRate(taxRate);
  }

  private setEntityId(entityId: number) {
    this.entityId = entityId;
  }

  private setTaxRate(taxRate: TaxRateInfo | null) {
    this.entityTaxRate = taxRate;
  }
}

const challengeTaxStore = new ChallengeTaxStore();
resetAllStore.addResetMethod(challengeTaxStore.setDefaultValues);

export { challengeTaxStore, ChallengeTaxStore };
